module.exports = __webpack_public_path__ + "img/u188_div.240cfae7.png";